export default __webpack_public_path__ + "static/media/telematico_new.5505c8a5.png";